import api from './client';

export const getShopConfig = async () => {
  const res = await api.get('/shop/config');
  return res.data;
};

export const createTopup = async (amount) => {
  const res = await api.post('/shop/topup', { amount });
  return res.data;
};

export const requestRefund = async (amount, reason = '') => {
  const res = await api.post('/shop/refund', { amount, reason });
  return res.data;
};

export const myRefunds = async () => {
  const res = await api.get('/shop/refunds/mine');
  return res.data;
};

// Admin
export const adminListRefunds = async (status) => {
  const qs = status ? `?status=${status}` : '';
  const res = await api.get(`/admin/refunds${qs}`);
  return res.data;
};

export const adminApproveRefund = async (id, note = '') => {
  const res = await api.post(`/admin/refunds/${id}/approve`, { admin_note: note });
  return res.data;
};

export const adminDeclineRefund = async (id, note = '') => {
  const res = await api.post(`/admin/refunds/${id}/decline`, { admin_note: note });
  return res.data;
};

export const adminReversePurchase = async (purchaseId, reason) => {
  const res = await api.post(`/admin/purchases/${purchaseId}/reverse`, { reason });
  return res.data;
};
